import { BucketingStrategy } from './bucketing-strategy';
import { BucketDef } from './bucket-def';
import { BaseBucketingStrategy } from './base-bucketing-strategy';
import * as moment from 'moment';

export class EOMBucketing extends BaseBucketingStrategy implements BucketingStrategy {

    constructor(todayStr: string, expandFirstBucket?: boolean) {
        super(todayStr, expandFirstBucket);
    }

    initBucketDefs() {
        // tslint:disable:max-line-length
        this.bucketDefs.push(new BucketDef(this.addExtraMonthForSpot(this.today.clone().endOf('month').startOf('day'), this.today, 2), this.today, true, '1M', this.bucketNamer));
        this.bucketDefs.push(new BucketDef(this.addExtraMonthForSpot(this.today.clone().add(1, 'month').endOf('month').startOf('day'), this.today, 2), this.startOfNextBucket(), true, '2M', this.bucketNamer));
        this.bucketDefs.push(new BucketDef(this.addExtraMonthForSpot(this.today.clone().add(2, 'month').endOf('month').startOf('day'), this.today, 2), this.startOfNextBucket(), true, '3M', this.bucketNamer));
        this.bucketDefs.push(new BucketDef(this.addExtraMonthForSpot(this.today.clone().add(3, 'month').endOf('month').startOf('day'), this.today, 2), this.startOfNextBucket(), true, '4M', this.bucketNamer));
        this.bucketDefs.push(new BucketDef(this.addExtraMonthForSpot(this.today.clone().add(4, 'month').endOf('month').startOf('day'), this.today, 2), this.startOfNextBucket(), true, '5M', this.bucketNamer));
        this.bucketDefs.push(new BucketDef(this.addExtraMonthForSpot(this.today.clone().add(5, 'month').endOf('month').startOf('day'), this.today, 2), this.startOfNextBucket(), true, '6M', this.bucketNamer));
        this.bucketDefs.push(new BucketDef(this.addExtraMonthForSpot(this.today.clone().add(6, 'month').endOf('month').startOf('day'), this.today, 2), this.startOfNextBucket(), true, '7M', this.bucketNamer));
    }

    bucketNamer(bucketDef: BucketDef): string {
        return bucketDef.bucketEndDate.format('MMM').toUpperCase();
    }

    addExtraMonthForSpot(bucketMoment: moment.Moment, baseMoment: moment.Moment, spotDays: number): moment.Moment {
        if (baseMoment.daysInMonth() - baseMoment.date() <= spotDays) {
            bucketMoment = bucketMoment.add(1, 'month').endOf('month').startOf('day');
        }
        return bucketMoment;
    }

    strategyName(): string {
        return 'EOM';
    }
}
